import { useEffect } from 'react'
import Swiper from 'swiper';
import SingleBlog3Img1 from '../assets/images/blog/single_blog3img1.jpg'
import SingleServicesImg1 from "../assets/images/services/single-services1.jpg"
import SingleServicesImg2 from "../assets/images/services/single-services2.jpg"
import SingleServicesImg3 from "../assets/images/services/single-services3.jpg"
import Blog1Img2 from '../assets/images/blog/blog1-img2.jpg'
import Blog1Img3 from '../assets/images/blog/blog1-img3.jpg'
import BlogImgGroup from '../assets/images/blog/blog-img-group.jpg'
import FixHeader from '../component/FixHeader'
import Loader from '../component/Loader'
import LatestBlog from '../component/LatestBlog'
import Footer from '../component/Footer'
import { useNavigate } from 'react-router-dom'

const BlogDetails3 = () => {
    const navigate = useNavigate()

    useEffect(() => {
        new Swiper(".single-slider", {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            speed: 1600,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        });
    }, []);
    return (
        <>
            <Loader></Loader>
            <FixHeader />
            {/* <!-- ====================================== Services Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="blog-section-one">
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Single Blog</h1>
                    <ul className="breadcrumb-list about-breadcrumb" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="line-slash" onClick={() => navigate("/BlogDetails3")}>Blog</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/BlogDetails3")}>Single Blog 3</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Services Section Two ===================================== --> */}
            <section className="about-section-two pb-0 overflow-hidden">
                <div className="container">
                    <div className="row single-services3-row">
                        <div className="col-xxl-8 col-xl-8 col-lg-12 col-md-12">
                            <div className="swiper single-slider">
                                <div className="swiper-wrapper ">
                                    <div className="swiper-slide">
                                        <img className="single-services1" data-aos="fade-down" src={SingleBlog3Img1} alt="single-services1" />
                                    </div>
                                    <div className="swiper-slide">
                                        <img className="single-services1" data-aos="fade-down" src={SingleServicesImg2} alt="single-services1" />
                                    </div>
                                    <div className="swiper-slide">
                                        <img className="single-services1" data-aos="fade-down"
                                            src={SingleServicesImg3} alt="single-services1" />
                                    </div>
                                    <div className="swiper-slide">
                                        <img className="single-services1" data-aos="fade-down"
                                            src={SingleServicesImg1} alt="single-services1" />
                                    </div>
                                </div>
                            </div>
                            <h2 className="Singleservices-text-main Singleservices-text-main2">How do you improve your content
                                writing skills?</h2>
                            <p className="commodo">Commodo semper bibendum adipiscing orci bibendum eu lectus sed. Commodo
                                cursus vitae augue luctus nibh. Congue sit quisque volutpat libero tempor a id cursus purus.
                                Pellentesque pellentesque scelerisque curabitur porta dolor. Amet vulputate vitae eget sit
                                rhoncus imperdiet. Odio justo nullam scelerisque quis bibendum. Cras ipsum vel diam praesent
                                tortor at elit sit. A risus molestie bibendum donec blandit adipiscing volutpat sollicitudin
                                aliquam. Nec arcu cras ultrices velit sed ligula. Iaculis elit vulputate sollicitudin
                                quisque ut faucibus.</p>
                            <p className="commodo pt-2">Facilisis nec malesuada enim viverra cras. Auctor dignissim tellus
                                vestibulum vitae hac amet. Suspendisse sit feugiat in pulvinar bibendum arcu nunc id. Duis
                                hac nisl dui facilisi placerat at mauris elit scelerisque. Turpis ornare auctor amet
                                vestibulum in magna aliquet ultricies netus. Adipiscing lobortis a interdum morbi etiam non.
                            </p>
                            <div className="small_blog" data-aos="fade-up">
                                <h3 className="integer">Mattis facilisis quam amet blandit faucibus. Sed in vitae
                                    montes sem quis faucibus bibendum massa. Eget volutpat molestie eget non netus nisl
                                    eleifend. Sit pellentesque posuere vitae scelerisque vel aliquet vulputate purus. Ac
                                    risus neque sed at pellentesque ultrices.
                                </h3>
                                <div className="line_client">
                                    <div className="line"></div>
                                    <h4 className="jordon">By Jordon Smith</h4>
                                </div>
                            </div>
                            <div className="single-services-imgs-group img-animation-style1 reveal">
                                <img src={Blog1Img2} alt="sevices2img5" />
                                <img src={Blog1Img3} alt="sevices2img6" />
                            </div>
                            <div className="img-animation-style2 reveal">
                                <img className="coming_soon_bg_blog" src={BlogImgGroup} alt="blog-img-group" />
                            </div>
                            <p className="commodo">Facilisis nec malesuada enim viverra cras. Auctor dignissim tellus vestibulum
                                vitae hac amet. Suspendisse sit feugiat in pulvinar bibendum arcu nunc id. Duis hac nisl dui
                                facilisi placerat at mauris elit scelerisque. Turpis ornare auctor amet vestibulum in magna
                                aliquet ultricies netus. Adipiscing lobortis a interdum morbi etiam non. Elit sed magna
                                risus tempor non quis. Nec pulvinar scelerisque in faucibus.</p>
                            <p className="commodo pt-2">Dis morbi cursus aliquam rutrum tortor amet. Mauris consequat libero
                                praesent pellentesque nibh sed eget urna. Leo at feugiat vel dictum eget quam et commodo
                                nullam. Nec arcu egestas adipiscing mollis dapibus justo non.</p>
                            <div className="button-container aos-init aos-animate" data-aos="fade-up">
                                <button>
                                    <svg className="prev-arrow-blog" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none">
                                        <g clipPath="url(#clip0_282_13)">
                                            <path d="M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                            <path d="M5 12L9 16" stroke="white" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                            <path d="M5 12L9 8" stroke="white" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_282_13">
                                                <rect width="24" height="24" fill="white"></rect>
                                            </clipPath>
                                        </defs>
                                    </svg>Prev
                                </button>
                                <div className="share-button view-modal">
                                    <button>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none">
                                            <g clipPath="url(#clip0_282_25)">
                                                <path
                                                    d="M3 12C3 12.7956 3.31607 13.5587 3.87868 14.1213C4.44129 14.6839 5.20435 15 6 15C6.79565 15 7.55871 14.6839 8.12132 14.1213C8.68393 13.5587 9 12.7956 9 12C9 11.2044 8.68393 10.4413 8.12132 9.87868C7.55871 9.31607 6.79565 9 6 9C5.20435 9 4.44129 9.31607 3.87868 9.87868C3.31607 10.4413 3 11.2044 3 12Z"
                                                    stroke="white" strokeWidth="2" strokeLinecap="round"
                                                    strokeLinejoin="round"></path>
                                                <path
                                                    d="M15 6C15 6.79565 15.3161 7.55871 15.8787 8.12132C16.4413 8.68393 17.2044 9 18 9C18.7956 9 19.5587 8.68393 20.1213 8.12132C20.6839 7.55871 21 6.79565 21 6C21 5.20435 20.6839 4.44129 20.1213 3.87868C19.5587 3.31607 18.7956 3 18 3C17.2044 3 16.4413 3.31607 15.8787 3.87868C15.3161 4.44129 15 5.20435 15 6Z"
                                                    stroke="white" strokeWidth="2" strokeLinecap="round"
                                                    strokeLinejoin="round"></path>
                                                <path
                                                    d="M15 18C15 18.7956 15.3161 19.5587 15.8787 20.1213C16.4413 20.6839 17.2044 21 18 21C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18C21 17.2044 20.6839 16.4413 20.1213 15.8787C19.5587 15.3161 18.7956 15 18 15C17.2044 15 16.4413 15.3161 15.8787 15.8787C15.3161 16.4413 15 17.2044 15 18Z"
                                                    stroke="white" strokeWidth="2" strokeLinecap="round"
                                                    strokeLinejoin="round"></path>
                                                <path d="M8.69922 10.7L15.2992 7.30005" stroke="white" strokeWidth="2"
                                                    strokeLinecap="round" strokeLinejoin="round">
                                                </path>
                                                <path d="M8.69922 13.3L15.2992 16.7" stroke="white" strokeWidth="2"
                                                    strokeLinecap="round" strokeLinejoin="round"></path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_282_25">
                                                    <rect width="24" height="24" fill="white"></rect>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </button>
                                </div>
                                <button>Next
                                    <svg className="next-arrow-blog" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none">
                                        <g clipPath="url(#clip0_282_20)">
                                            <path d="M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                            <path d="M15 16L19 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                            <path d="M15 8L19 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_282_20">
                                                <rect width="24" height="24" fill="white"></rect>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <LatestBlog />
            <Footer />
        </>
    )
}

export default BlogDetails3